import { render } from "./AutoModal.vue?vue&type=template&id=71ca463b&scoped=true"
import script from "./AutoModal.vue?vue&type=script&lang=js"
export * from "./AutoModal.vue?vue&type=script&lang=js"

import "./AutoModal.vue?vue&type=style&index=0&id=71ca463b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ca463b"]])

export default __exports__